import React from 'react';
import { Section } from './Section';
import { ComparisonTable } from './ComparisonTable';
import { transformationRows } from '../data/tables';
export function Transformation() {
  return <Section background="paper" labelledBy="transformation-heading" data-id="element-295" data-mp="mlmn8slmaxlz">
      <h2 id="transformation-heading" className="mx-auto max-w-3xl text-center font-serif text-[26px] font-semibold leading-[1.15] text-ink sm:text-3xl lg:text-[40px]" data-id="element-296" data-mp="moh82l8jmkfx">
        From hoping nobody mentions anything, to being the teacher they tell first
      </h2>

      <ComparisonTable className="mt-10 sm:mt-12" rows={transformationRows} leftLabel="Before the system" rightLabel="With Screen & Adapt™" data-id="element-297" data-mp="11hams4fzqwjj" />
    </Section>;
}